export default __webpack_public_path__ + "static/media/2526 knife block B side.b91d68ce.png";